module.exports = __webpack_public_path__ + "img/crossed-reload.81f473e.svg";